/**
 * Wrapper around the browser-specific implementation of the path module.
 *
 * @packageDocumentation
 * @internal
 * @hidden
 */

/**
 * @internal
 * @hidden
 */
export { join as joinPath } from "path";
